import { defineMessages } from 'react-intl';

export default defineMessages({
  welcome: {
    id: 'homepage.welcome',
    description: 'welcome message',
    defaultMessage: 'Welcome from no language found.',
  },
});
